import { BaseBus } from "./BaseBus";

export class InvoiceProfit extends BaseBus {
    constructor(data: InvoiceProfit = null) {
        super(data);
    }
    get dollarProfit(): number {
        return this.amount - this.costPlusUseTax;
    }
    set dollarProfit(value: number) { }
    get percentProfit(): number {
        return this.amount > 0 ? this.dollarProfit / this.amount : 0;
    }
    set percentProfit(value: number) { }
    invoiceId: any;
    isAvalara: boolean;
    isRetailTax: boolean;
    useTax: number;
    cost: number;
    get costPlusUseTax(): number {
        return this.cost + this.useTax;
    }
    set costPlusUseTax(value: number) {}
    amount: number;
}
